module.exports = __webpack_public_path__ + "static/media/betyaros_background_red.8aabde15.jpg";